import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";

import PageTitle from "../../components/PageTitle/PageTitle";
import AboutCard from "./AboutCard";

function AboutMarathonTimer() {
    return (
        <div className="content-section">
            <div className="container">
                <PageTitle titleTag={[]} title={"說說配速計算機"} descriptionLines={["手把手教你使用配速計算機,自己的配速自己算！"]} />

                <AboutCard />
            </div>
        </div>
    );
}

export default AboutMarathonTimer;
